// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ql5m","col":"styles_col__2Q_im"};